/**
 * Validates international phone numbers
 * Accepts formats like:
 * - +85212345678 (Hong Kong)
 * - +12125551234 (US)
 * - +447911123456 (UK)
 * @param phone - Phone number to validate
 * @returns Whether the phone number is valid
 */
export const validatePhoneNumber = (phone: string): boolean => {
  if (!phone) return false;
  // Matches international phone numbers:
  // +[country code][phone number]
  const phoneRegex = /^\+?\d{8,}$/;
  return phoneRegex.test(phone);
};

/**
 * Get phone number validation error message
 * @param phone - Phone number to validate
 * @returns Error message if invalid, undefined if valid
 */
export const getPhoneNumberError = (phone: string): string | undefined => {
  if (!phone) return 'Phone number is required';
  if (!validatePhoneNumber(phone)) {
    return 'Invalid phone number format';
  }
  return undefined;
};
